import React from "react";
import DialogWrapper from "./DialogWrapper";

const DialogSubmit = ({
    open,
    actionMethod,
    title = "Gravar Registo",
    fullWidth = true,
    fullScreen = false,
    message = "Tens a certeza que queres gravar este registo?"
}) => {

    return (
        <DialogWrapper
            open={open}
            title={title}
            onClose={() => actionMethod("cancel")}
            onCancel={() => actionMethod("cancel")}
            onConfirm={() => actionMethod("submit")}
            labelCancel="Cancelar"
            labelConfirm="Confirmar"
            fullWidth={fullWidth}
            fullScreen={fullScreen}>
            {message}
        </DialogWrapper>
    )
}

export default DialogSubmit;
